import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { cities, services } from '../config/seoContent';
import { FONT_FAMILY } from '../common/sharedFunctions';

// Bloque de enlazado interno para SEO: distribuye autoridad entre las páginas
// programáticas (ciudad y servicio×ciudad) y mejora la rastreabilidad e
// indexación de las búsquedas long-tail ("grúa para carro en {ciudad}").
const linkSx = {
  color: '#cfcfcf',
  textDecoration: 'none',
  fontFamily: FONT_FAMILY,
  fontSize: 14,
  display: 'inline-block',
  padding: '4px 10px',
  margin: '4px 5px',
  borderRadius: '999px',
  border: '1px solid #2a2a2a',
  transition: 'all .15s ease',
};

const Section = ({ title, links }) => (
  <Box sx={{ mb: 4 }}>
    <Typography component="h3" sx={{ fontFamily: FONT_FAMILY, fontWeight: 'bold', fontSize: 16, color: '#fff', mb: 1.2 }}>
      {title}
    </Typography>
    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
      {links.map((l, i) => (
        <Link
          key={i}
          to={l.to}
          style={linkSx}
          onMouseOver={(e) => { e.currentTarget.style.borderColor = 'gold'; e.currentTarget.style.color = '#fff'; }}
          onMouseOut={(e) => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#cfcfcf'; }}
        >
          {l.label}
        </Link>
      ))}
    </Box>
  </Box>
);

export default function SeoLinks({ currentCity, currentService }) {
  const sections = [];

  if (currentService && currentCity) {
    // Pagina servicio x ciudad: mismo servicio en otras ciudades + otros servicios aqui.
    sections.push({
      title: `${currentService.name} en otras ciudades`,
      links: cities.filter((c) => c.slug !== currentCity.slug).map((c) => ({
        to: `/grua/${currentService.slug}/${c.slug}`,
        label: `${currentService.name} en ${c.name}`,
      })),
    });
    sections.push({
      title: `Otros servicios en ${currentCity.name}`,
      links: services.filter((s) => s.slug !== currentService.slug).map((s) => ({
        to: `/grua/${s.slug}/${currentCity.slug}`,
        label: `${s.name} en ${currentCity.name}`,
      })),
    });
  } else if (currentCity) {
    // Pagina de ciudad: servicios en esta ciudad + grua en otras ciudades.
    sections.push({
      title: `Servicios de grúa en ${currentCity.name}`,
      links: services.map((s) => ({
        to: `/grua/${s.slug}/${currentCity.slug}`,
        label: `${s.name} en ${currentCity.name}`,
      })),
    });
    sections.push({
      title: 'Grúa en otras ciudades de Colombia',
      links: cities.filter((c) => c.slug !== currentCity.slug).map((c) => ({
        to: `/grua/${c.slug}`,
        label: `Grúa en ${c.name}`,
      })),
    });
  } else {
    // Landing principal: todas las ciudades + servicios principales.
    sections.push({
      title: 'Grúa por ciudad en Colombia',
      links: cities.map((c) => ({ to: `/grua/${c.slug}`, label: `Grúa en ${c.name}` })),
    });
    sections.push({
      title: 'Servicios de grúa en Colombia',
      links: services.map((s) => ({ to: `/grua/${s.slug}/bogota`, label: s.name })),
    });
  }

  return (
    <Box component="nav" aria-label="Enlaces de grúa por ciudad y servicio" sx={{ backgroundColor: '#000', color: '#fff', px: { xs: 2, md: 8 }, py: { xs: 5, md: 7 } }}>
      <Typography component="h2" sx={{ fontFamily: FONT_FAMILY, fontWeight: 'bold', fontSize: { xs: 22, md: 30 }, mb: 3 }}>
        Cobertura de grúas en toda Colombia
      </Typography>
      {sections.map((s, i) => (
        <Section key={i} title={s.title} links={s.links} />
      ))}
    </Box>
  );
}
